import { api } from "@/lib/api";

const b64 = (s) => { const p = "=".repeat((4 - (s.length % 4)) % 4); const r = atob((s + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...r].map((c) => c.charCodeAt(0))); };

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const currentSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
};

export const enablePush = async () => {
  if (!pushSupported()) throw new Error("Votre navigateur ne gère pas les notifications. Sur iPhone, ajoutez d'abord CASHMY à l'écran d'accueil.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Autorisez les notifications pour CASHMY dans les réglages du navigateur.");
  const reg = (await navigator.serviceWorker.getRegistration()) || (await navigator.serviceWorker.register("/sw.js"));
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/notifications/push/key");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64(data.key) }));
  await api.post("/notifications/push/subscribe", sub.toJSON());
  return sub;
};

export const disablePush = async () => {
  const sub = await currentSubscription();
  if (!sub) return;
  await api.post("/notifications/push/unsubscribe", sub.toJSON()).catch(() => null);
  await sub.unsubscribe();
};
